import giftOrderQueries from '@apis/queries/giftOrderQueries';
import { ErrorResponse } from '@models/error';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

function useGiftOrderResult(giftOrderNo: string) {
    const { t } = useTranslation('gift');
    const { pop } = useFlow();
    const query = useQuery({
        ...giftOrderQueries.result(giftOrderNo),
        enabled: !!giftOrderNo,
    });

    useEffect(() => {
        if (query.status === 'error') {
            const e = query.error as AxiosError<ErrorResponse>;
            toast.error(e.response?.data?.message || t('giftSent.loadError'));
            pop();
        }
    }, [query.status, query.error, pop, t]);

    return query;
}

export default useGiftOrderResult;
